/**
 * @class Package
 */
export default class Package {
    /**
     * @param {Number}  id
     * @param {String}  name
     * @param {String}  displayName
     * @param {Number}  unit
     * @param {String}  unitCode
     * @param {Number}  nominalAmount
     * @param {Number}  filling
     * @param {Number}  fillingMl
     * @param {Boolean} isGravimetric
     */
    constructor(id, name, displayName, unit, unitCode, nominalAmount, filling, fillingMl, isGravimetric) {
        this._id = id;
        this._name = name;
        this._displayName = displayName;
        this._unit = unit;
        this._unitCode = unitCode;
        this._nominalAmount = nominalAmount;
        this._filling = filling;
        this._fillingMl = fillingMl;
        this._isGravimetric = isGravimetric;
        this._imageId = -1;

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Package");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @param {Number} id
     */
    set id(id) {
        this._id = id;
    }

    /**
     * @return {String}
     */
    get name() {
        return this._name;
    }

    /**
     * @param {String} name
     */
    set name(name) {
        this._name = name;
    }

    /**
     * @return {String}
     */
    get displayName() {
        return this._displayName;
    }

    /**
     * @param {String} displayName
     */
    set displayName(displayName) {
        this._displayName = displayName;
    }

    /**
     * @return {Number}
     */
    get size() {
        return this._nominalAmount;
    }

    /**
     * @return {Number}
     */
    get unit() {
        return this._unit;
    }

    /**
     * @param {Number} unit
     */
    set unit(unit) {
        this._unit = unit;
    }

    /**
     * @return {String}
     */
    get unitCode() {
        return this._unitCode;
    }

    /**
     * @param {String} unitCode
     */
    set unitCode(unitCode) {
        this._unitCode = unitCode;
    }

    /**
     * @return {Number}
     */
    get nominalAmount() {
        return this._nominalAmount;
    }

    /**
     * @param {Number} nominalAmount
     */
    set nominalAmount(nominalAmount) {
        this._nominalAmount = nominalAmount;
    }

    /**
     * @return {Number}
     */
    get filling() {
        return this._filling;
    }

    /**
     * @param {Number} filling
     */
    set filling(filling) {
        this._filling = filling;
    }

    /**
     * @return {Number}
     */
    get fillingMl() {
        return this._fillingMl;
    }

    /**
     * @param {Number} fillingMl
     */
    set fillingMl(fillingMl) {
        this._fillingMl = fillingMl;
    }

    /**
     * @return {Boolean}
     */
    get isGravimetric() {
        return this._isGravimetric;
    }

    /**
     * @param {Boolean} isGravimetric
     */
    set isGravimetric(isGravimetric) {
        this._isGravimetric = isGravimetric;
    }

    /**
     * @return {Number}
     */
    get imageId() {
        return this._imageId;
    }

    /**
     * @param {Number}  imageId
     */
    set imageId(imageId) {
        this._imageId = imageId;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Package (" + this._id + ")";
    }

    /**
     * @return {Boolean}
     */
    isCustom = () => {
        return this._id <= 0;
    };

    /**
     * Clones Package object and updates imageId property.
     *
     * @param   {Number}    imageId
     * @return  {Object}
     */
    updateImageId = (imageId) => {
        let newPackage = new Package(
            this._id,
            this._name,
            this._displayName,
            this._unit,
            this._unitCode,
            this._nominalAmount,
            this._filling,
            this._fillingMl,
            this._isGravimetric
        );
        newPackage.imageId = imageId;

        return newPackage;
    };

    /**
     * Clones Package object and updates filling properties.
     *
     * @param   {Number}    fillingMl
     * @return  {Object}
     */
    updateFillingMl = (fillingMl) => {
        let newPackage = new Package(
            this._id,
            this._name,
            this._displayName,
            this._unit,
            this._unitCode,
            this._nominalAmount,
            fillingMl / 1000,
            fillingMl,
            this._isGravimetric
        );
        newPackage.imageId = this._imageId;

        return newPackage;
    };

    /**
     * @return {Object}
     */
    formatedObject() {
        return {
            id: this._id,
            name: this._name,
            displayName: this._displayName,
            unit: this._unit,
            unitCode: this._unitCode,
            nominalAmount: this._nominalAmount,
            filling: this._filling,
            fillingMl: this._fillingMl,
            isGravimetric: this._isGravimetric
        };
    }
}
